/**
 * @author xyguo
 * @date 2021-8-19
 * @desc 远程评估详情查看
 */
import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { WizAuthority,WizBraftEditorPlus } from "../../../common";
import { Row, Col } from 'antd';
import { element } from "prop-types";

let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils } = framework_tool
let { WizCard, WizSelect, WizForm, Wizmessage, WizRow, WizCol, WizInput, WizSpin,WizModal,WizBraftEditor } = component_tool
let { Session } = utils_tool


class OrgRemoteEvaluationDetailInfo extends WizContainer {
  componentName = 'orgRemoteEvaluationDetailInfo'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {};
    if (history.location && history.location.pathname === '/remoteAuth/orgRemoteEvaluationDetailList/orgRemoteEvaluationDetailInfo') {
      if (history.location && history.location.record) {
        detailInfo = history.location.record
        Session.set('orgRemoteEvaluationDetailInfo', detailInfo)
      } else {
        detailInfo = Session.get('orgRemoteEvaluationDetailInfo') || {}
      }
    }
    this.state = {
      time: undefined,
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
    if (this.detailInfo.id) {
      this.doAction({
        path: 'orgRemoteAuthDetail/selectOneById',
        payload: {
          key: "getOrgRemoteAuthDetailInfo",
          apiParams: {
            id: this.detailInfo.id
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    orgRemoteEvaluationDetailInfo: this._getOrgRemoteEvaluationDetailInfoOver.bind(this)
  }

  _getOrgRemoteEvaluationDetailInfoOver(nextProps, nextState) {
    if (nextProps.orgRemoteEvaluationDetailInfo.code == 1) {
      this.detailInfo = nextProps.orgRemoteEvaluationDetailInfo.data;
      nextState.time = new Date().getTime();
    } 
    return true;
  }


  authorityInfo = () => {
    let authInfo = {}
    authInfo.personIds = this.detailInfo.personInfoList
    return (
      <WizAuthority value={authInfo} mode='Show' showBlock={false} />
    )
  }

  getImgInfo = () => {
    let record = this.detailInfo
    let show = []
    let url = getOssFilePath(record.img)
    show.push( <Col span={4.5} ><img height={80} width={130} style={{margin:5, objectFit: 'cover' }} src={url}/></Col>)
    return (
      <Row type='flex' justify = 'start' gutter={{ xs: 4.5, sm: 16, md: 24}}>
        {show}
      </Row>
    )
    
  }

  _render() {
    const items = this.detailInfo
    return (
      <React.Fragment>
        <WizSpin tip={'加载中'} spinning={this.props.orgRemoteAuthDetailLoading}>
          <WizCard>
            <Descriptions column={1}  bordered={true}>
              <Descriptions.Item label='检核场次'>{items.name}</Descriptions.Item>
              <Descriptions.Item label='检核项目'>{items.remoteAuthName}</Descriptions.Item>
              <Descriptions.Item label='经销商简称'>{items.shortName}</Descriptions.Item>
              <Descriptions.Item label='经销商代码'>{items.dealerNumber}</Descriptions.Item>
              <Descriptions.Item label='检核时间'>{items.startToEndDateStr}</Descriptions.Item>
              <Descriptions.Item label='讲师'>{items.lectureName}</Descriptions.Item>
              <Descriptions.Item label='受众'>{this.authorityInfo()}</Descriptions.Item>
              <Descriptions.Item label='是否可回看'>{items.lookingBack ? "是" : "否"}</Descriptions.Item>
              <Descriptions.Item label='是否自动录制'>{items.autoRecording ? "是" : "否"}</Descriptions.Item>
              {/* <Descriptions.Item label='讲师视频'>{items.hostVideo ? "是" : "否"}</Descriptions.Item> */}
              <Descriptions.Item label='封面'>{this.getImgInfo('img')}</Descriptions.Item>
              <Descriptions.Item label='检核终端'>{items.authWay===0 ? '培训助手':'企业微信'}</Descriptions.Item>
              <Descriptions.Item label='检核状态'>{items.authStateCh}</Descriptions.Item>
              <Descriptions.Item label='总得分'>{items.authState===4 ? items.score : ""}</Descriptions.Item>
              <Descriptions.Item label='通过状态'>{items.passCh}</Descriptions.Item>
            </Descriptions>
          </WizCard>
        </WizSpin>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { orgRemoteAuthDetail } = state;
  const orgRemoteEvaluationDetailInfo = modelUtils.getModelEntity(orgRemoteAuthDetail, "getOrgRemoteAuthDetailInfo");
  const load = modelUtils.getLoadingState(state, ['orgRemoteAuthDetail']);
  return {
    orgRemoteEvaluationDetailInfo,
    ...load
  }
};

export default connect(mapStateToProps)(OrgRemoteEvaluationDetailInfo)

